import React from "react";

function Partnership() {
  return (
    <div className="p-5">
      <h3 className="text-center text-customgGrayShade1 font-normal text-lg py-5">
        rentwise is in partnership with:
      </h3>
      <div className="flex justify-around gap-6 lg:gap-0 text-3xl font-bold overflow-x-hidden  lg:overflow-hidden">
        <h2>
          rent<span className="text-customyellow">w</span>ise
          <span className="text-customyellow">.</span>
        </h2>
        <h2>
          rent<span className="text-customyellow">w</span>ise
          <span className="text-customyellow">.</span>
        </h2>
        <h2>
          rent<span className="text-customyellow">w</span>ise
          <span className="text-customyellow">.</span>
        </h2>
        <h2>
          rent<span className="text-customyellow">w</span>ise
          <span className="text-customyellow">.</span>
        </h2>
        <h2>
          rent<span className="text-customyellow">w</span>ise
          <span className="text-customyellow">.</span>
        </h2>
      </div>
    </div>
  );
}

export default Partnership;
